import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';

import fixtureReducers from './fixture';
import performanceReducers,{performanceAttributeReducers} from './performance';
import userReducers from './user';
import headerSearchReducers from './header-search'

import {loadData, isLogin } from '../actions'


const allReducers = combineReducers({
	headerSearch : headerSearchReducers,
	fixture : fixtureReducers,
	user : userReducers,
	performance : performanceReducers,
	attribute : performanceAttributeReducers
});
const store = createStore(allReducers,applyMiddleware(thunk));

store.dispatch(loadData);
store.dispatch(isLogin);

export default store;